<div class="container mt-2">
  <!-- Driver Details Section -->
 <div class="card mb-4 shadow-sm">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="card-title text-primary mb-0">Driver Details</h5>
      <button class="btn btn-primary btn-sm" (click)="handleBack()">
        ← Back
      </button>
    </div>
    <hr />

    <div class="row">
      <div class="col-md-4 mb-3">
        <h6 class="mb-1">Driver Name:</h6>
        <p class="text-muted mb-0">{{ name }}</p>
      </div>
      <div class="col-md-4 mb-3">
        <h6 class="mb-1">Mobile Number:</h6>
        <p class="text-muted mb-0">+91 {{ phoneNumber }}</p>
      </div>
    </div>
  </div>
</div>


  <!-- Transaction History Table -->
  <div class="card shadow-sm">
    <!-- <div class="card-header bg-primary text-white">
      <h5 class="mb-0">Transaction History</h5> <span><button (click)="exportTableToExcel('transactionTable', 'TableData')">Export To Excel</button></span>
    </div> -->
    <div
      class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
    >
      <h5 class="mb-0">Reviews</h5>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table
          class="table table-bordered table-hover mb-0"
          id="transactionTable"
        >
          <thead class="table-light">
            <tr>
              <th>Created By</th>
              <th>Rating</th>
              <th>Comment</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            <tr class="fw-bold" *ngFor="let data of allReviews">
              <td>
                {{ data.createdBy }}
              </td>
              <td>
                <ng-container *ngFor="let star of [1, 2, 3, 4, 5]">
                  <i
                    class="fa"
                    [ngClass]="
                      star <= data.rating
                        ? 'fa-star text-warning'
                        : 'fa-star-o text-secondary'
                    "
                  ></i>
                </ng-container>
              </td>

              <td>{{ data.comment }}</td>
              <td>
                {{ data.createdAt | date : "dd MMM yyyy hh:mm a" : "en-IN" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ngb-pagination
        (pageChange)="driverReviews((page = $event))"
        [collectionSize]="totalItems"
        [(page)]="page"
        [pageSize]="itemsPerPage"
        [maxSize]="3"
        [rotate]="true"
        [boundaryLinks]="false"
      >
      </ngb-pagination>
    </div>
  </div>
</div>
